import { CalculatorIcon, MenuItem } from "@rothoblaas/design-system";
import { FC } from "react";
import { useNavigate } from "react-router-dom";
import useI18n from "../../hooks/useTranslations";

const Menu: FC = () => {
  const i18n = useI18n();
  const navigate = useNavigate();

  return (
    <MenuItem
      icon={<CalculatorIcon />}
      label={i18n.translation.calculations.my}
      href="/my-calculations"
      onNavigate={navigate}
    />
  );
};

export default Menu;
